<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
  >
    <path
      d="M28.076 14.205L26.1443 15.3211L27.2594 17.2525"
      :stroke="clr ? clr : '#B2B2B2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.9198 33.7955L21.8514 32.6795L20.7363 30.748"
      :stroke="clr ? clr : '#B2B2B2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.7051 28.2129C15.783 30.0784 17.5722 31.5341 19.8189 32.1361C20.4371 32.3018 21.0562 32.3869 21.6694 32.4125"
      :stroke="clr ? clr : '#B2B2B2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M33.2942 19.7882C32.2163 17.9227 30.4271 16.467 28.1804 15.865L28.1765 15.864C27.5583 15.6983 26.9393 15.6132 26.326 15.5876"
      :stroke="clr ? clr : '#B2B2B2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M21.4526 28L26.5435 28C27.3471 28 27.998 27.3491 27.998 26.5455L27.998 21.4545C27.998 20.6509 27.3471 20 26.5435 20L21.4526 20C20.649 20 19.998 20.6509 19.998 21.4545L19.998 26.5455C19.998 27.3491 20.649 28 21.4526 28Z"
      :stroke="clr ? clr : '#B2B2B2'"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
